<p-card styleClass="p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between">
      <h2>My Registration Stats</h2>
      <app-icon-button 
        [icon]="icons.solid.faGear" 
        tooltip="Update My Registration Goals" 
        tooltipPosition="top"
        (click)="updateMyRegistrationGoals()"
      ></app-icon-button>
    </div>
  </ng-template>
  <div class="flex flex-col gap-4">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- Week Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">This Week</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.week | number}}
            </div>
            <div class="stat-count">
              {{weekStats.totalOriginal | number}} registered, {{weekStats.teamCount | number}} team{{weekStats.teamCount !== 1 ? 's' : ''}}
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="weekPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>

      <!-- Month Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">{{currentMonth}}</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.month | number}}
            </div>
            <div class="stat-count">
              {{monthStats.totalOriginal | number}} registered, {{monthStats.teamCount | number}} team{{monthStats.teamCount !== 1 ? 's' : ''}}
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="monthPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>

      <!-- Year Stats -->
      <div class="flex flex-col items-center text-center">
        <div class="stat-info">
          <div class="stat-header">
            <span class="stat-title">{{currentYear}}</span>
          </div>
          <div class="stat-description flex flex-col gap-1">
            <div class="stat-subtitle">
              <span class="goal-label">Goal:</span> {{goals.year | number}}
            </div>
            <div class="stat-count">
              {{yearStats.totalOriginal | number}} registered, {{yearStats.teamCount | number}} team{{yearStats.teamCount !== 1 ? 's' : ''}}
            </div>
          </div>
        </div>
        <div class="stat-knob">
          <p-knob 
            [(ngModel)]="yearPercentage" 
            [readonly]="true"
            [size]="100"
            [strokeWidth]="10"
            [showValue]="true"
            [valueTemplate]="'{value}%'">
          </p-knob>
        </div>
      </div>
    </div>
  </div>
</p-card> 